import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import FadeIn from 'react-fade-in';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

function PaymentPixQRCodeModalTitle({ title, subTitle, className, style }) {
  const classes = useStyles({ subTitle });

  return (
    <FadeIn>
      <div className={classNames(classes.container, className)} style={style}>
        <div className={_.isEmpty(subTitle) ? classes.subTitle : classes.title}>
          {title}
        </div>
        <div className={classes.subTitle}>{subTitle}</div>
      </div>
    </FadeIn>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid red',
  },
  // title: {
  //   fontSize: layoutDefaults.biggerFontSize,
  // },
  // subTitle: {
  //   fontSize: layoutDefaults.biggestFontSize,
  // },

  title: {
    // fontSize: layoutDefaults.biggerFontSize,
    fontSize: ({ subTitle }) =>
      (subTitle?.length ?? 0) < 10
        ? layoutDefaults.biggerFontSize
        : layoutDefaults.biggestFontSize,
  },
  subTitle: {
    fontSize: ({ subTitle }) =>
      (subTitle?.length ?? 0) < 10
        ? layoutDefaults.biggestFontSize
        : layoutDefaults.biggerFontSize,
  },
});

export { PaymentPixQRCodeModalTitle };
